(function () {
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name +
      "=" +
      encodeURIComponent(value) +
      ";expires=" +
      expires.toUTCString() +
      ";path=/;SameSite=Lax";
  }

  // 1. Read ttclid from URL
  const ttclid = getQueryParam("ttclid");

  // 2. Store in cookie if exists
  if (ttclid) {
    setCookie("ttclid", ttclid, 30); // store for 30 days
    console.log("ttclid stored:", ttclid);
  }
})();
